import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageAdmins,
  PageAdmin,
} from '../pages/admins';
// import {
//   PageClients,
//   PageClient,
// } from '../pages/clients';

const RouteUsers = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/admins`} />
      </Route>

      <Route exact path={`${path}/admins`}>
        <PageAdmins />
      </Route>
      <Route exact path={`${path}/admins/:_id`}>
        <PageAdmin />
      </Route>

      {/* <Route exact path={`${path}/clients`}>
        <PageClients />
      </Route>
      <Route exact path={`${path}/clients/:_id`}>
        <PageClient />
      </Route> */}
    </Switch>
  );
};

export default RouteUsers;
